export default __webpack_public_path__ + "locales/lv/UploadPanel.json?hash=2b1e92bc6fb8793fea08ddd480e96f34";